import { Typography } from "@mui/material";

import { WarningField } from "components/inputs/basic-input/assets";

import { StyledInputError, StyledInputErrorBox } from "./styles";
import { IInputErrorProps } from "./types";

const InputError: React.FC<IInputErrorProps> = ({
  children,
  errors,
  wrapperSx,
  ...props
}: IInputErrorProps) => {
  return (
    <StyledInputErrorBox sx={wrapperSx}>
      {children}
      {errors && (
        <StyledInputError className="error-message" {...props}>
          <WarningField />
          <Typography
            color={(theme) => theme.palette.error.main}
            variant={"error"}
          >
            {errors}
          </Typography>
        </StyledInputError>
      )}
    </StyledInputErrorBox>
  );
};

export default InputError;
